import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { HttpClient } from '@angular/common/http';
import { ProcessControlService } from 'src/app/services/process-control.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { StorageUtil } from 'src/app/utils/storage.util';
import { SqsMessageDialogComponent } from '../sqs-message-dialog/sqs-message-dialog.component';

interface LogAction {
  datetime: string;
  description: string;
}

interface InvoiceDetailData {
  log: LogAction[];
  invoices?: any[];
  sqsMessageId?: string;
  totalOrders?: number;
  orderIds?: number[];
  totalInvoices?: number;
}

@Component({
  selector: 'app-group-detail-dialog',
  templateUrl: './group-detail-dialog.component.html',
  styleUrls: ['./group-detail-dialog.component.scss']
})
export class GroupDetailDialogComponent implements OnInit {
  group: any;
  processControlOrder: any = null;
  detailData: InvoiceDetailData | null = null;
  loading = false;
  error: string | null = null;

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private http: HttpClient,
    private processControlService: ProcessControlService,
    private invoiceService: InvoiceService,
    private dialogService: DialogService
  ) {
    this.group = this.config.data?.group;
  }

  ngOnInit() {
    if (this.group && this.group.orderIds && this.group.orderIds.length > 0) {
      this.loadProcessControlOrder(this.group.orderIds[0]);
    }
  }

  loadProcessControlOrder(orderId: number) {
    this.loading = true;
    this.error = null;

    const userId = StorageUtil.getUserId();
    const marinaId = StorageUtil.getMarinaId();

    this.processControlService.getProcessControlOrderByOrderId(orderId).subscribe({
      next: (response) => {
        if (response) {
          this.processControlOrder = response;
          if (response.urlDetalhe) {
            this.loadDetailData(response.urlDetalhe);
          } else {
            this.loading = false;
          }
        } else {
          this.error = 'ProcessControlOrder não encontrado para este pedido';
          this.loading = false;
        }
      },
      error: (err) => {
        console.error('Erro ao buscar ProcessControlOrder:', err);
        if (err.status === 404) {
          this.error = 'ProcessControlOrder não encontrado para este pedido';
        } else {
          this.error = 'Erro ao carregar dados do processo';
        }
        this.loading = false;
      }
    });
  }

  loadDetailData(url: string) {
    this.http.get(url, {
      responseType: 'text',
      headers: {
        'Accept': 'application/json, text/plain, */*'
      }
    }).subscribe({
      next: (response: string) => {
        try {
          this.detailData = JSON.parse(response);
          this.loading = false;
        } catch (parseError) {
          console.error('Erro ao fazer parse do JSON:', parseError);
          this.error = 'Erro ao processar dados do log';
          this.loading = false;
        }
      },
      error: (err) => {
        console.error('Erro ao carregar detalhes:', err);
        this.error = 'Erro ao carregar log de detalhes';
        this.loading = false;
      }
    });
  }

  formatDateTime(dateTime: string): string {
    if (!dateTime) return '';
    const date = new Date(dateTime);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  }

  formatDate(dateTime: string | null): string {
    if (!dateTime) return 'N/A';
    const date = new Date(dateTime);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  }

  getTimeDifference(index: number): string {
    if (!this.detailData || !this.detailData.log || index === 0) return '0.00s';
    const current = new Date(this.detailData.log[index].datetime);
    const previous = new Date(this.detailData.log[index - 1].datetime);
    const diff = (current.getTime() - previous.getTime()) / 1000;
    return diff.toFixed(2) + 's';
  }

  getActionIcon(description: string): string {
    if (description.includes('Início')) return 'pi pi-play-circle';
    if (description.includes('Erro') || description.includes('inválida')) return 'pi pi-times-circle';
    if (description.includes('sucesso') || description.includes('concluído')) return 'pi pi-check-circle';
    if (description.includes('AVISO')) return 'pi pi-exclamation-triangle';
    if (description.includes('Grupo')) return 'pi pi-sitemap';
    if (description.includes('Mensagem enviada')) return 'pi pi-send';
    if (description.includes('Invoice criada')) return 'pi pi-file';
    return 'pi pi-info-circle';
  }

  getActionClass(description: string): string {
    if (description.includes('Erro') || description.includes('inválida')) return 'error-action';
    if (description.includes('sucesso') || description.includes('concluído')) return 'success-action';
    if (description.includes('AVISO')) return 'warning-action';
    return 'info-action';
  }

  viewSqsMessage() {
    const sqsMessageId = this.group?.sqsMessageId || this.detailData?.sqsMessageId;
    if (!sqsMessageId || sqsMessageId === 'N/A') {
      return;
    }

    this.invoiceService.getSqsMessageByMessageId(sqsMessageId).subscribe({
      next: (sqsMessage) => {
        this.dialogService.open(SqsMessageDialogComponent, {
          header: 'Mensagem SQS',
          width: '80%',
          height: '80%',
          data: {
            sqsMessage: sqsMessage,
            sqsMessageId: sqsMessageId
          }
        });
      },
      error: (err) => {
        console.error('Erro ao buscar mensagem SQS:', err);
        alert('Erro ao carregar mensagem SQS: ' + (err.error?.message || err.message || 'Erro desconhecido'));
      }
    });
  }

  hasError(): boolean {
    return this.processControlOrder?.success === false ||
           (this.detailData?.log && this.detailData.log.some(log => log.description.includes('ERRO')));
  }

  getSqsMessageId(): string | null {
    return this.group?.sqsMessageId || this.detailData?.sqsMessageId || null;
  }
}
